bam-notifications-wrapper {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 29;
  width: auto;
  text-align: right;
  display: flex;
  flex-direction: column;

  .bam-notifications-wrapper__notifications {
    display: flex;
    flex-direction: column;
  }

  .has-direct-link {  
    flex-direction: row;
  }

  &.has-chatbot {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  @include desktop() {
    bottom: 24px;
    right: 24px;
    text-align: left;
  }

  &.is-active {
    z-index: 31;
  }
}
